import { render, staticRenderFns } from "./RadioView.vue?vue&type=template&id=1718c3dd&scoped=true&"
import script from "./RadioView.vue?vue&type=script&lang=js&"
export * from "./RadioView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1718c3dd",
  null
  
)

export default component.exports